import { defineEvent } from '../types/event';
export var PDP_SIZE_SELECTOR_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_PDP_Size_Selectors'
        }
    ]
});
